import { combineReducers } from 'redux-immutable'

import result from './result/reducer'

export default combineReducers({
  result,
})
